// Result: 21 Jun 2024

export const createdUpdatedAt = (date: string) => {
    return new Date(date).toLocaleDateString([], {
        year: 'numeric',
        month: 'short',
        day: 'numeric'
    })
}
